
webpack.register(
    'modules/carousel/carousel',
    function() {
        return import('modules/carousel/carousel');
    },
    true
);